module.exports = __webpack_public_path__ + "assets/img/btn_chip_1.fa286bbe.png";